export const values = <K extends string = string, V = unknown>(obj: Record<K, V>): V[] => Object.keys(obj).map(key => obj[key as K]);
